var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseChimney2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "House-chimney") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2539 22.924C13.8399 22.924 13.5039 22.588 13.5039 22.174V16.174C13.5039 15.76 13.1679 15.424 12.7539 15.424H11.2539C10.8399 15.424 10.5039 15.76 10.5039 16.174V22.174C10.5039 22.588 10.1679 22.924 9.75391 22.924H3.75391C3.33991 22.924 3.00391 22.588 3.00391 22.174V13.924C3.00391 13.51 3.33991 13.174 3.75391 13.174C4.16791 13.174 4.50391 13.51 4.50391 13.924V21.424H9.00391V16.174C9.00391 14.933 10.0129 13.924 11.2539 13.924H12.7539C13.9949 13.924 15.0039 14.933 15.0039 16.174V21.424H19.5039V13.924C19.5039 13.51 19.8399 13.174 20.2539 13.174C20.6679 13.174 21.0039 13.51 21.0039 13.924V22.174C21.0039 22.588 20.6679 22.924 20.2539 22.924H14.2539Z",
    fill: "#320E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.753883 13.174C0.553883 13.174 0.364883 13.096 0.223883 12.954C-0.0681172 12.662 -0.0681172 12.186 0.223883 11.893L10.4139 1.704C10.8379 1.28 11.4029 1.046 12.0049 1.046C12.6059 1.046 13.1709 1.28 13.5959 1.704L15.8019 3.91C15.9089 3.626 16.1829 3.423 16.5039 3.423H20.2539C20.6679 3.423 21.0039 3.759 21.0039 4.173V9.112L23.7839 11.892C24.0759 12.184 24.0759 12.66 23.7839 12.953C23.6419 13.095 23.4539 13.173 23.2539 13.173C23.0539 13.173 22.8649 13.095 22.7239 12.953L12.5349 2.766C12.3939 2.625 12.2059 2.547 12.0049 2.547C11.8039 2.547 11.6159 2.625 11.4739 2.766L1.28388 12.955C1.14288 13.096 0.953883 13.174 0.753883 13.174ZM19.5039 7.614V4.924H17.2539V5.363L19.5039 7.614Z",
    fill: "#320E3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseChimney2);
export default __webpack_public_path__ + "static/media/house-chimney-2.fff0c719fc538fa620ad322964980ce2.svg";
export { ForwardRef as ReactComponent };